<div class="project-copy-dialog">
  <h1 mat-dialog-title>Make a copy</h1>

  <div mat-dialog-content class="dialog-content">
    <!-- Source project info -->
    <div class="section">
      <h3 class="section-title">Copy from</h3>
      <div class="source-project-info">
        <mat-icon class="project-icon">folder</mat-icon>
        <div class="project-details">
          <div class="project-name">{{ data.projectName || data.projectId }}</div>
          <div class="project-id">{{ data.projectId }}</div>
        </div>
      </div>
    </div>

    <!-- Target project configuration -->
    <div class="section">
      <h3 class="section-title">Copy to</h3>

      <!-- Project ID input -->
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>New project ID</mat-label>
        <input
          matInput
          [(ngModel)]="targetProjectId"
          [formControl]="projectIdFormControl"
          (input)="onProjectIdChange()"
          (focus)="clearError()"
          placeholder="Enter new project ID"
          [disabled]="loading"
        />
        <mat-icon matSuffix>folder_copy</mat-icon>
        @if (projectIdFormControl.invalid && projectIdFormControl.touched) {
          <mat-error>
            {{ getProjectIdErrorMessage() }}
          </mat-error>
        }
        <mat-hint>Project ID will be used as the folder name</mat-hint>
      </mat-form-field>

      <!-- Sharing settings checkbox -->
      <div class="sharing-settings">
        <mat-checkbox [(ngModel)]="copySharingSettings" [disabled]="loading" color="primary">
          Copy sharing settings
        </mat-checkbox>
        <div class="sharing-hint">
          <mat-icon class="hint-icon">info</mat-icon>
          <span>
            If unchecked, you will become the owner of the new project. If checked, all current project members will
            have the same access to the new project.
          </span>
        </div>
      </div>
    </div>

    <!-- Progress bar -->
    @if (loading) {
      <div class="progress-container">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <div class="progress-message">Creating copy of project...</div>
      </div>
    }

    <!-- Error message -->
    @if (error) {
      <div class="error-message">
        <mat-icon class="error-icon">error</mat-icon>
        <span>{{ error }}</span>
      </div>
    }
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <div class="left-actions">
      <!-- Empty for now, could add help button later -->
    </div>

    <div class="right-actions">
      <button mat-button (click)="onCancel()" [disabled]="loading">Cancel</button>

      <button mat-raised-button color="primary" (click)="onCopy()" [disabled]="!isFormValid() || loading">
        <mat-icon>content_copy</mat-icon>
        Make a copy
      </button>
    </div>
  </div>
</div>
